import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "text", "classes", "tag"];
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { createUseStyles } from 'react-jss';
import withMemo from '../../../decorators/withMemo';
import { mergeStyles } from '../../../utils/StyleUtils';
import MarkdownText from '../../MarkdownText';
import styles from './styles';
var useStyles = createUseStyles(styles);
function FormErrorText(props) {
  var className = props.className,
    text = props.text,
    classesProp = props.classes,
    tag = props.tag,
    others = _objectWithoutProperties(props, _excluded);
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  if (!text) {
    return null;
  }
  return /*#__PURE__*/React.createElement(MarkdownText, _extends({
    text: text,
    inline: true,
    tag: tag
  }, others, {
    className: cx(classes.container, className)
  }));
}
FormErrorText.styles = styles;
FormErrorText.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  text: PropTypes.string,
  tag: PropTypes.string
};
FormErrorText.defaultProps = {
  classes: {},
  className: null,
  text: '',
  tag: 'span'
};
export default withMemo()(FormErrorText);